const locales = {
    EN: {
        name: "Name",
        building: "Building name",
        description: "Description",
        order: "Order",
        status: "Status",
        actions: "Actions",
        marker: "Marker",
        markerName: "Marker name",
        buildingComponent: "BuildingComponent",
        buildingComponents: "BuildingComponents",
        createdTs: "Creation date",
        blueprints: "Blueprints",
        markers: "Markers",
        markUp: "Manage markers on blueprint",
        values: "Values",
        inUse: "In Use",
        firstname: "First name",
        building: "Building name",
        marker: "Marker name",
        description: "Description",
        street: "Street",
        number: "No.",
        postalcode: "Postcal code",
        city: "City",
        country: "Country",
        mobile: "Mobile",
        email: "Email",
        applicationDate: "Application date",
        date: "Date",
        order: "Order",
        class: "Class",
        attribute: "Attribute",
        attributes: "Attributes",
        value: "value",
        installer: "Installer",
        solution: "Solution",
        solutions: "Solutions",
        username: "Username",
        password: "Password",
        uploadBlueprintFile: "Upload blueprint file with minimum resolution 640x480 (.jpg , .pdf file)",
        comments: "Comments",
        products: "Products",
        approved: "Approved",
        broken: "Broken",
        dimensions: "Dimensions",
        width: "Width (mm)",
        height: "Height (mm)",
        length: "Wall  thickness (mm)",
        diameter: "Diameter (mm)",
        unit: "Unit",
        amount: "Amount",
        details: "Details",
        required: "is required",
        invalid: "is invalid",
        warning: "Warning",
        qrIdExists: "Error",
        success: "Success",
        cached: "Offline",
        saveChanges: "Save changes?",
        overrideQRId: "This service penetration is already linked with a qr code.Do you want to assign it with a new qr code?",
        qrIdExists: "This qr code can not be applied. A different service penetration uses this qr code!",
        success: "This qr code is successfully linked with this service penetration!",
        areYouSure: "Are you sure you want to delete this?",
        cached: "This services penetration will be linked once you go online",
        unsaved: "Changes were made. Do you want to save changes?",
        yes: "Yes",
        no: "No",
        currentPassword: "Current password",
        newPassword: "New password",
        confirmPassword: "Confirm password",
        changePassword: "Change password",
        active: "Active",
        noBlueprint: "I currently don't have a blueprint",
        deadline: "Deadline",
        newProject: "New Project",
        newBuildingComponent: "New Building Component",
        newBlueprint: "New Blueprint",
        save: "Save",
        add: "Add",
        close: "Close",
        login: "Sign in",
        newInstaller: "Add installer",
        addPicture: "Add picture",
        newSolution: "Add solution",
        addQRCode: "Link QR code",
        offline: "Offline",
        addMarkers: "Add Markers",
        cancel: "Cancel",
        download: "download",
        edit: "Edit",
        addProduct: "Add product",
        home: "Home",
        projects: "Projects",
        buildingComponents: "Building Components",
        blueprints: "Blueprints",
        markers: "Markers",
        project: "Project",
        buildingComponent: "Building Component",
        blueprint: "Blueprint",
        marker: "Marker",
        address: "Address",
        contact: "Contact",
        settings: "Settings",
        back: "Back",
        installer: "Installer",
        users: "Users",
        camera: "Camera",
        solutions: "Solutions",
        solution: "Solution",
        products: "Products",
        product: "Product",
        todo: "To-do",
        todos: "To-dos",
        myTodos: "My to-dos",
        todosForInstallers: "to-dos for installers",
        userNotFound: "The password you entered is incorrect.",
        selectSolution: "Please select a solution",
        success: "Success",
        error: "Something went wrong",
        cached: "Changes will be saved once you are online",
        unsaved: "Changes were made, don't forget to save before you leave.",
        offlineUsers: "is working offline on blueprint: ",
        notOnline: "Connection lost. Please connect to the internet",
        inReadOnly: "Currently in readonly mode. Click edit to make changes.",
        newSolution: "New Solution",
        chooseSolution: "Choose a solution",
        draw: "Draw on the blueprint to create a marker!",
        wait1: "Loading... This may take a few moments...",
        wait2: "Preparing Final Form",
        deadline: "Deadline",
        reports: "Reports",
        archivedReports: "Old reports",
        qrcodeNotLinked: "This qr code is not yet linked, or is linked with markers not on this blueprint.",
        scanQRCode: "Scan a linked QR code",
        attachment: "Attachment",
        isEditing: "Is editing",
        editStart: "Started editing",
        noaccess: "No access",
        fillinrequiredfields: "Fill in the required fields",
        withlogo: "With logo",
        withoutlogo: "Without logo",
        search: "Search",
        chooseFile: "Choose file (5MB max)",
        continuereadonly: "Someone is working on this blueprint. Do you still want to visit the page without having the ability to edit?",
        blueprintLocked: "is busy editing",
        blueprintLockedSince: "is busy editing since",
        takeOver: "Take over",
        customsolutions: "Custom solutions",
        noproducts: "No products",
        addpicture: "Add picture",
        help: "Help",
        noresults: "No results",
        signout: "Sign out",
        viewMore: "View more",
        usethisinmarker: "Use this in marker",
        addyourownlogo: "add you own logo",
        delete: 'delete',
        step: 'Step',
        application: 'Application',
        solutionselector: 'Solution Selector',
        selectsolution: 'Select Solution',
        inProcess: 'In process',
        solutionsList: "Solutions list",
        deleteSolution: "Delete solution",
        selectUsedProducts: "Select used products",
        showAll: "Show all",
        new: "New",
        useSolutionSelector: 'Find solution using the solution selector',
        orUseDropdown: 'Or find it in the list',
        useDropdown: 'Find solution in the list',
        info_broken: "Markers with their latest image with status broken uploaded. Meaning that the penetration seals are broken.",
        info_inProcess: "Markers that have no images, but some details and information are filled in.",
        info_approved: "Markers that have the penetration seal installed correctly.",
        info_new: "Newly created markers, markers with no info filled in or no images uploaded.",
        info_solutions_list: "You can have multiple penetration seals (solutions) in one marker point.",
        info_attributes: "",
        info_dimensions: "",
        info_marker_details: "",
        info_solution_details: "",
        info_custom_solutions: "",
        info_firelog_solutions: "",
        info_attributes: "",
        showBlueprintImage: "Show Blueprint Image",
        changeImage: "change image",
        newAttribute: "New Attribute",
        enterTheNameOfYourCustomSolution: "Enter the name of your custom solution",
        yourProducts: "List of your products",
        enterTheNameOfYourProductAndClickThePlusSignToAddToTheList: "Enter the name of your product and click the plus sign to add to the list.",
        changeSolution: "change solution",
        viewSolution: "View solution",
        notLinked: "Not linked with QR code",
        linked: "Linked with QR code",
        open: "Open",
        archive: "archive",
        restore: "restore",
        archivedProjects: "Archived Projects",
        pictures: "Pictures",
        discard: "discard",
        findInList: "Search in list",
        findInSolutionSelector: "Search in Solution Selector",
        uploadBlueprintImage: "Upload",
        networkIssues: "Network issue",
        checkConnectionAndTryAgain: "Check your connection and try again",
        retry: 'Retry',
        noBlueprints: 'No blueprints',
        noProjects: 'No projects',
        noBuildingComponents: 'No building components',
        noArchivedProjects: 'No archived projects',
        noCustomSolutions: 'No custom solutions',
        projectDetails: "Project info",
        buildingComponentDetails: "Building info",
        user: "user",
        newUser: "new user",
        breakLock: "lock",
        changeLogo: "change logo",
        vat: "VAT number",
        requestTrial: "Request a free trial",
        freeDemo: "Free Trial",
        company: "Company",
        demoRegistrationSuccessful: "Trial request received",
        requestReceived: "Request received",
        contactYou: "Thanks for your interest in Firelog. A representative will be in touch shortly to schedule your interactive demo.",
        firstFloor: "example: First floor",
        blockA: "example: Block A",
        takealook: "All-in-one software for Fire-resistant sealing registration & reporting",
        manufacturerIndepentent: "Independent from any Manufacturer",
        multiplesealsonmarker: "Less administration, better focus on workload, faster documenting your fire protection sealings of a building",
        anydevice: "All functionality available on any device (PC, Tablet, smartphone both IOS & Android supported)",
        multilanguage: "Highly Customizable tailored to the customer needs",
        highlyCustomizable: "Easy, fast & always accessible",
        requestADemo: "Request a demo",
        signup: "Sign up",
        activeProjects: "Active projects",
        profile: "Profile",
        license: "License",
        storage: "Storage",
        chooseYourPartner: "Choose your partner",
        partner: "partner",
        noPartner: "No partner",
        requestTrialFourteenDays: "Register for a 14-days free trial account",
        itemsPerPage: "Items per page",
        belgium: "Belgium",
        unitedKingdom: "United Kingdom",
        germany: "Germany",
        austria: "Austria",
        romania: "Romania",
        sweden: "Sweden",
        hungary: "Hungary",
        netherlands: "Netherlands",
        norway: "Norway",
        switzerland: "Switzerland",
        spain: "Spain",
        downloadLogbook: "Download logbook",
        saveMarkerPosition: "Save markers position",
        newMarker: "Add new marker",
        fullscreen: "Fullscreen",
        noLogin: "I don't have an account",
        report: "Report a problem",
        send: "Send",
        checkInbox: "Check your inbox.",
        resetPasswordInstruction: "You will receive an email with further instructions.",
        resetPassword: "Reset password",
        forgotPassword: "Forgot password?",
        areyouSureYouWantToUpgrade: "Are you sure you want to add AMOUNT GB for PRICE per month?",
        perMonth: "Per month",
        chooseHowMuchStorageYouWantToAdd: "Choose how much storage you want to add. Notice: You can have up to 40 GB storage in total. Want more? Please contact us.",
        addStorage: "Add storage",
        manageUsers: "Select which projects, building components and blueprints this person can access.",
        properties: "Properties",
        termsOfService: "Terms of Services",
        readAndAccepted: "I have read and accepted the Terms of Use and Privacy Policy.",
        agree: "Agree",
        contactFunction: "Function",
        contactEmail: "Contact email",
        contactEmailHint: "We will contact you on this email address.",
        loginEmail: "Login email",
        loginEmailHint: "Email address which you can log in with.",
        loginAlreadyExist: "Login email is already been used.",
        whatsnew: "What's new",
        deleteBlueprintImage: "Delete blueprint image",
        '7profile': "Admin",
        '8profile': "Read-only",
        '14profile': "Installer",
        '15profile': "No access",
        clone: "Clone",
        cloneAttributeWithValues: "Clone this attribute with underlying values?",
        giveADifferentName: "Enter a different name than the original",
        ignore: "Ignore",
        areyousureyouwanttoignorethis: "Are you sure you want to ignore this?",
        addReportToThisSolution: "Add report to this solution",
        info_delete_attribute: "You can delete attributes or values if you have made them yourself and if they haven't been used yet on a marker.",
        info_clone_attribute: "You can clone attributes with their underlying values so that you don't have to create new ones.",
        info_sync_attribute: "This will sync the standard firelog attributes and values. It is recommended to this once in a while.",
        info_drag_attribute: "You can change the order by holdclicking and draging it to the correct position.",
        info_star_attribute: "Standard attributes and values from Firelog",
        newReports: "New reports",
        moveMarker: "Move markers",
        markerLabel: "Custom marker name",
        blueprintSeparated: "Blueprint image separated",
        blueprintSeparatedHint: "Get your blueprint image with markers separated in high quality (.jpg)",
        withDocuments: "Include documents",
        withDocumentsHint: "Certificates, data sheets,... This can take more time",
        selectYourPage: "Select your page",
        downloadlogbookasaWordFile: "Download logbook as a Word file",
        takingSnapshot: "Taking a snapshot of blueprint image",
        modifiedBy: "Modified by",
        installPWA: "Install Firelog on your device: tap on ",
        addToHomeScreen: "and then Add to homescreen",
        readyForOffline: "Ready for offline, turn off your wifi/4g to work offline and turn it back on once you are done.",
        goOnline: "Don't forget to connect to the internet to save your changes. Don't refresh or close the app."
    },
    NL: {
        building: "Naam gebouw",
        description: "Beschrijving",
        order: "Volgorde",
        status: "Status",
        actions: "Acties",
        marker: "Marker",
        markerName: "Markernaam",
        buildingComponent: "Bouwdeel",
        buildingComponents: "Bouwdelen",
        createdTs: "Aanmaakdatum",
        blueprints: "Bouwplannen",
        markers: "Markers",
        markUp: "Beheer markers op bouwplan",
        values: "Waarden",
        inUse: "In gebruik",
        name: "Naam",
        firstname: "Voornaam",
        building: "Naam gebouw",
        marker: "Markernaam",
        street: "Straat",
        number: "nummer",
        postalcode: "Postcode",
        city: "Stad",
        country: "Land",
        mobile: "GSM",
        email: "Email",
        applicationDate: "Applicatie datum",
        date: "Datum",
        order: "Volgorde",
        class: "Klasse",
        attribute: "Attribuut",
        attributes: "Attributen",
        installer: "Monteur",
        users: "Gebruikers",
        solution: "Oplossing",
        solutions: "Oplossingen",
        username: "Gebruikersnaam",
        password: "Wachtwoord",
        uploadBlueprintFile: "Upload bouwplan afbeelding met minimum resolution 640x480 (.jpg .pdf bestand)",
        comments: "Commentaar",
        products: "Producten",
        approved: "Goedgekeurd",
        broken: "Gebroken",
        dimensions: "Afmetingen",
        width: "Breedte (mm)",
        height: "Hoogte (mm)",
        length: "Wanddikte (mm)",
        diameter: "Diameter (mm)",
        unit: "Eenheid",
        amount: "Aantal",
        details: "Gegevens",
        required: "is vereist.",
        warning: "Opgelet",
        qrIdExists: "Error",
        success: "Voltooid",
        cached: "Geen verbinding",
        saveChanges: "Wijzigingen opslaan?",
        overrideQRId: "Deze doorvoering is al gelinkt met een qr code. Wil je een nieuwe toevoegen?",
        qrIdExists: "Deze qr code is al gelinkt met een andere doorvoering!",
        success: "Qr code is succesvol gelinkt!",
        areYouSure: "Ben je zeker dat je dit wil verwijderen?",
        cached: "Deze doorvoering zal worden opgeslagen eens je online verbonden bent.",
        unsaved: "Er zijn wijzigingen aangebracht. Wilt u de wijzigingen opslaan?",
        yes: "Ja",
        no: "Neen",
        currentPassword: "Huidig wachtwoord",
        newPassword: "Nieuw wachtwoord",
        confirmPassword: "Wachtwoord bevestigen",
        changePassword: "Wachtwoord wijzigen",
        active: "Actief",
        noBlueprint: "Voorlopig heb ik geen bouwplan",
        deadline: "Deadline",
        newProject: "Nieuw Project",
        newBuildingComponent: "Nieuw Bouwdeel",
        newBlueprint: "Nieuw Bouwplan",
        save: "Opslaan",
        add: "Toevoegen",
        close: "Sluiten",
        login: "Aanmelden",
        addPicture: "Voeg foto toe",
        newInstaller: "Monteur aanmaken",
        newSolution: "Oplossing Aanmaken",
        addQRCode: "Link QR code",
        offline: "Offline",
        addMarkers: "Markers toevoegen",
        cancel: "Annuleren",
        download: "downloaden",
        edit: "Bewerken",
        addProduct: "Product toevoegen",
        home: "Home",
        projects: "Projecten",
        buildingComponents: "Bouwdelen",
        blueprints: "Bouwplannen",
        markers: "Markers",
        project: "Project",
        buildingComponent: "Bouwdeel",
        blueprint: "Bouwplan",
        marker: "Marker",
        address: "Adres",
        contact: "Contact",
        settings: "Instellingen",
        solutions: "Oplossingen",
        solution: "Oplossing",
        products: "Producten",
        product: "Product",
        todo: "Te doen",
        todos: "Taken",
        myTodos: "Mijn taken",
        todosForInstallers: "Taken voor monteurs",
        newSolution: "Nieuwe oplossing",
        chooseSolution: "Kies een oplossing",
        draw: "Teken op het bouwplan om een marker toe te voegen.",
        wait1: "Laden... Dit kan enkele momenten duren...",
        wait2: "Preparing Final Form",
        userNotFound: "Het ingevoerde wachtwoord is onjuist",
        selectSolution: "Gelieve een oplossing te selecteren",
        success: "Succes",
        error: "Error",
        cached: "Wijzigingen worden opgeslagen eens je online verbonden bent.",
        unsaved: "Er zijn wijzigingen aangebracht, vergeet niet op te slaan voordat u vertrekt.",
        offlineUsers: "werkt offline op bouwplan: ",
        notOnline: "Maak verbinding met internet",
        inReadOnly: "Momenteel in readonly modus. klik op bewerken om wijzigingen aan te brengen.",
        deadline: "Deadline",
        reports: "Meldingen",
        archivedReports: "Oude meldingen",
        scanQRCode: "Een gelinkte QR code scannen",
        qrcodeNotLinked: "Deze qr code is nog niet gelinkt",
        attachment: "Bijlage",
        isEditing: "Bezig met bewerken",
        editStart: "Begon met bewerken",
        noaccess: "Geen toegang",
        fillinrequiredfields: "Vul de verplichte velden in",
        withlogo: "Met logo",
        withoutlogo: "Zonder logo",
        search: "Zoeken",
        chooseFile: "Kies bestand (5MB max)",
        continuereadonly: "Iemand is bezig met bewerken op dit bouwplan. Wilt u de pagina nog steeds bezoeken zonder de mogelijkheid te hebben om te bewerken",
        blueprintLocked: "is bezig met bewerken",
        blueprintLockedSince: "is bezig met bewerken sinds",
        takeOver: "Overnemen",
        customsolutions: "Eigen oplossingen",
        noproducts: "Geen producten",
        addpicture: "Foto toevoegoen",
        help: "Help",
        noresults: "Geen resultaten",
        signout: "Uitloggen",
        viewMore: "Zie meer",
        usethisinmarker: "Gebruik dit in marker",
        addyourownlogo: "voeg uw eigen logo toe",
        delete: 'verwijderen',
        step: 'Stap',
        application: 'Installatie instructies',
        solutionselector: 'Solution Selector',
        selectsolution: 'Kies een oplossing',
        inProcess: 'In bewerking',
        solutionsList: "Lijst oplossingen",
        deleteSolution: "Oplossing verwijderen",
        selectUsedProducts: "Selecteer gebruikte producten",
        showAll: "Toon alles",
        new: "Nieuw",
        useSolutionSelector: 'Zoek de juiste oplossing met behulp van de solution selector',
        orUseDropdown: 'Of zoek in de lijst',
        useDropdown: 'Selecteer de juiste oplossing in deze lijst',
        info_broken: "Marker die minstens 1 gebroken doorvoering heeft.",
        info_inProcess: "Markeringen zonder afbeeldingen, maar sommige zaken zijn ingevuld.",
        info_approved: "Doorvoeringen die correct zijn geïnstalleerd.",
        info_new: "Nieuw gemaakte markers. Markers zonder ingevulde info en geen afbeeldingen geüpload.",
        info_solutions_list: "U kunt meerdere doorvoeringen (oplossingen) op een marker hebben.",
        info_attributes: "",
        showBlueprintImage: "Bouwplan afbeelding openen",
        changeImage: "afbeelding wijzigen",
        newAttribute: "Nieuw attribuut",
        enterTheNameOfYourCustomSolution: "Vul de naam van jouw oplossing in",
        yourProducts: "Lijst van jouw producten",
        enterTheNameOfYourProductAndClickThePlusSignToAddToTheList: "Vul de naam van jouw product in and klik op het plustekentje om toe te voegen in de lijst",
        changeSolution: "oplossing wijzigen",
        viewSolution: "oplossing weergeven",
        notLinked: "Niet gekoppeld met qr-code",
        linked: "Gekoppeld met qr-code",
        open: "Weergeven",
        archive: "archiveren",
        restore: "herstellen",
        archivedProjects: "Gearchiveerde projecten",
        pictures: "Afbeeldingen",
        discard: "Annuleren",
        findInList: "Zoek in lijst",
        findInSolutionSelector: "Zoek in Solution Selector",
        uploadBlueprintImage: "Uploaden",
        networkIssues: "Netwerk probleem",
        checkConnectionAndTryAgain: "Controleer uw verbinding en probeer opnieuw",
        retry: 'opnieuw proberen',
        noBlueprints: 'Geen bouwplannen',
        noProjects: 'Geen projecten',
        noBuildingComponents: 'Geen bouwdelen',
        noArchivedProjects: 'Geen gearchiveerde projecten',
        noCustomSolutions: 'Geen eigen oplossingen',
        projectDetails: "Project info",
        buildingComponentDetails: "Bouwdeel info",
        user: "gebruiker",
        newUser: "nieuwe gebruiker",
        breakLock: "slot",
        changeLogo: "logo wijzigen",
        vat: "BTW-nummer",
        requestTrial: "Vraag gratis test toegang aan",
        freeDemo: "Gratis proefperiode",
        company: "Bedrijf",
        firstFloor: "vb: Eerste verdieping",
        blockA: "vb: Block A",
        demoRegistrationSuccessful: "Proefperiode-aanvraag ontvangen",
        requestReceived: "Aanvraag ontvangen",
        contactYou: "Bedankt voor uw interesse in Firelog. Binnenkort neemt een medewerker contact met u op om uw interactieve demo in te plannen.",
        takealook: "Zie hoe u brandwerende afdichtingen kunt registreren met Firelog",
        manufacturerIndepentent: "Onafhankelijk van alle fabrikanten",
        multiplesealsonmarker: "Minder administratie, sneller documenteren van uw brandwerende afdichtingen van een gebouw",
        anydevice: "Beschikbaar op elk apparaat (pc, tablet, smartphone, zowel IOS als Android ondersteund)",
        multilanguage: "Gemakkelijk en snel",
        highlyCustomizable: "Eenvoudig instelbaar op maat van de klant",
        requestADemo: "Vraag een demo aan",
        signup: "Inschrijven",
        activeProjects: "Actieve projecten",
        profile: "Profiel",
        license: "Licentie",
        storage: "Opslag",
        chooseYourPartner: "Bent u reeds klant bij één van onze partners? Gelieve aan te geven wat van toepassing is",
        partner: "partner",
        noPartner: "Geen partner",
        requestTrialFourteenDays: "Registreer nu voor een gratis testtoegang van 14 dagen",
        itemsPerPage: "Items per pagina",
        belgium: "België",
        unitedKingdom: "Verenigd Koninkrijk",
        germany: "Duitsland",
        austria: "Oostenrijk",
        romania: "Roemenië",
        sweden: "Zweden",
        hungary: "Hongarije",
        netherlands: "Nederland",
        norway: "Noorwegen",
        switzerland: "Zwitserland",
        spain: "Spanje",
        downloadLogbook: "Logboek downloaden",
        saveMarkerPosition: "Markeerpositie opslaan",
        newMarker: "Nieuwe marker toevoegen",
        fullscreen: "Volledig scherm",
        noLogin: "Ik heb geen account",
        report: "Probleem melden",
        send: "Versturen",
        checkInbox: "Controleer je inbox.",
        resetPasswordInstruction: "Je zal een e-mail ontvangen met verdere instructies.",
        resetPassword: "Wachtwoord resetten",
        forgotPassword: "Wachtwoord vergeten?",
        areyouSureYouWantToUpgrade: "Weet u zeker dat u AMOUNT GB voor PRICE per maand wilt toevoegen?",
        perMonth: "Per maand",
        chooseHowMuchStorageYouWantToAdd: "Kies hoeveel opslagruimte je wilt toevoegen. Opmerking: u kunt in totaal maximaal 40 GB aan opslagruimte hebben. Wilt u meer? Gelieve ons te contacteren.",
        addStorage: "Opslag toevoegen",
        manageUsers: "Selecteer tot welke projecten, bouwdelen en bouwplannen deze persoon toegang heeft.",
        properties: "Eigenschappen",
        termsOfService: "Servicevoorwaarden",
        readAndAccepted: "Ik heb de gebruiksvoorwaarden en het privacybeleid gelezen en geaccepteerd.",
        agree: "Akkoord gaan",
        contactFunction: "Fuctie",
        contactEmail: "Contact email",
        contactEmailHint: "We nemen contact met u op via deze e-mail.",
        loginEmail: "Login email",
        loginEmailHint: "Emailadres waarmee u kunt inloggen.",
        loginAlreadyExist: "E-mailadres voor inloggen is al gebruikt.",
        whatsnew: "Wat is er nieuw",
        deleteBlueprintImage: "Bouwplan afbeelding verwijderen",
        '7profile': "Admin",
        '8profile': "Alleen lezen",
        '14profile': "Monteur",
        '15profile': "Geen toegang",
        clone: "Klonen",
        cloneAttributeWithValues: "Kloon dit attribuut met onderliggende waarden?",
        giveADifferentName: "Voer een andere naam in dan het origineel",
        ignore: "Negeren",
        areyousureyouwanttoignorethis: "Ben je zeker dat je dit wil negeren?",
        info_delete_attribute: "U kunt attributen verwijderen als u ze zelf heeft gemaakt en als ze nog niet zijn gebruikt op een marker.",
        info_clone_attribute: "U kunt attributen klonen met hun onderliggende waarden, zodat u niet handmatig nieuwe hoeft te maken.",
        info_sync_attribute: "Hiermee worden de standaard attributen en waarden van firelog gesynchroniseerd. Het wordt aanbevolen om dit af en toe te doen.",
        info_drag_attribute: "U kunt de volgorde wijzigen door erop te klikken en deze naar de juiste positie te slepen.",
        info_star_attribute: "Standaardattributen en waarden van Firelog",
        newReports: "Nieuwe meldingen",
        moveMarker: "Markers verplaatsen",
        markerLabel: "Eigen marker naam",
        blueprintSeparated: "Bouwplan afbeelding gescheiden",
        blueprintSeparatedHint: "Krijg uw bouwplan afbeelding met markeringen gescheiden in hoge kwaliteit (.jpg)",
        withDocuments: "Met documenten",
        withDocumentsHint: "Certificaten, data sheets, ... dit kan langer duren",
        selectYourPage: "Selecteer pagina",
        downloadlogbookasaWordFile: "Logbook downloaden als Word document",
        takingSnapshot: "Momentopname nemen van bouwplan afbeelding",
        modifiedBy: "Aangepast door",
        installPWA: "Installeer Firelog op uw apparaat: klik op ",
        addToHomeScreen: "en dan toevoegen aan Startscherm",
        readyForOffline: "Klaar voor offline, zet je wifi / 4g uit om offline te werken en zet hem weer aan als je klaar bent.",
        goOnline: "Vergeet niet om verbinding te maken met het internet om uw wijzigingen op te slaan. Vernieuw of sluit de app niet."
    },
    DE: {
        name: "Name",
        building: "Gebäudename",
        description: "Beschreibung",
        order: "Reihenfolge",
        status: "Status",
        actions: "Tätigkeiten",
        marker: "Markierung",
        markerName: "Markierungsbezeichnung",
        buildingComponent: "Bauabschnitt",
        buildingComponents: "Bauabschnitte",
        createdTs: "Eingabedatum",
        blueprints: "Geschosse",
        markers: "Markierungen",
        markUp: "Markierung im Bauplan setzen",
        values: "Wert",
        inUse: "In Gebrauch",
        name: "Name",
        firstname: "Vorname",
        building: "Gebäudename",
        marker: "Markierungsbezeichnung",
        description: "Beschreibung",
        street: "Straße",
        number: "Nummer",
        postalcode: "PLZ",
        city: "Ort",
        country: "Land",
        mobile: "Handynummer",
        email: "Emailadresse",
        applicationDate: "Montagedatum",
        date: "Datum",
        order: "Reihenfolge",
        class: "Klasse",
        attribute: "Eigenschaft",
        attributes: "Eigenschaften",
        value: "Wert",
        installer: "Monteur",
        solution: "Lösung",
        solutions: "Lösungen",
        username: "Benutzername",
        password: "Passwort",
        uploadBlueprintFile: "Hochladen von bauplan bild mit einer Mindestauflösung von 640 x 480 (.jpg .pdf Datei)",
        comments: "Kommentare",
        products: "Produkte",
        approved: "Genehmigt",
        broken: "Defekt",
        dimensions: "Abmessungen",
        width: "Breite (mm)",
        height: "Höhe (mm)",
        length: "Wanddicke (mm)",
        diameter: "Durchmesser (mm)",
        unit: "Einheit",
        amount: "Menge",
        details: "Details",
        required: "vorgeschrieben",
        invalid: "ungültig",
        overrideQRId: "Achtung",
        qrIdExists: "Dieser QR Code kann nicht genutzt werden. Eine andere Abschottung hat bereits diesen QR Code zugewiesen bekommen",
        success: "Erfolgreich",
        saveChanges: "Änderungen sichern?",
        overrideQRId: "Diese Abschottung ist bereits mit einem QR Code verknüpft. Möchten Sie der Abschottung einen neuen QR Code zuordnen?",
        qrIdExists: "Dieser qr Code kann nicht genutzt werden. Eine andere Abschottung hat bereits diesen qr Code.",
        success: "Der qr Code wurde erfolgreich mit der Abschottung verknüpft.",
        areYouSure: "Sind Sie sicher das Sie diese Angabe löschen möchten?",
        cached: "Diese Abschottung wird verknüft sobald sie wieder Online sind.",
        unsaved: "Änderungen erfolgreich. Möchten Sie die Änderungen speichern?",
        yes: "Ja",
        no: "Nein",
        currentPassword: "Aktuelles Passwort",
        newPassword: "Neues Passwort",
        confirmPassword: "Passwort bestätigen",
        changePassword: "Passwort ändern",
        active: "Activ",
        noBlueprint: "Aktuell gibt es keine Baupläne.",
        deadline: "Fertigstellungsdatum",
        newProject: "Neues Projekt",
        newBuildingComponent: "Neuer Bauabschnitt",
        newBlueprint: "Neues Stockwerk/ Etage",
        save: "Speichern",
        add: "Ergänzen",
        close: "Schließen",
        login: "Einloggen",
        newInstaller: "Monteur hinzufügen",
        addPicture: "Bild hinzufügen",
        newSolution: "Lösung hinzufügen",
        addQRCode: "Link QR code",
        offline: "Offline",
        addMarkers: "Marker hinzufügen",
        cancel: "Stornieren",
        download: "Download",
        edit: "Bearbeiten",
        addProduct: "Product hinzufügen",
        home: "Home",
        projects: "Projekte",
        buildingComponents: "Bauabschnitte",
        markers: "Markierung",
        project: "Projekt",
        buildingComponent: "Bauabschnitt",
        blueprint: "Bauplan",
        marker: "Markierung",
        address: "Adresse",
        contact: "Kontakt",
        settings: "Einstellungen",
        back: "Zurück",
        installer: "Monteur",
        users: "Benutzer",
        camera: "Kamera",
        solutions: "Lösungen",
        solution: "Lösung",
        products: "Produkte",
        product: "Produkt",
        userNotFound: "Das eigegebene Passwort ist nicht korrekt.",
        selectSolution: "Bitte wählen Sie eine Lösung",
        success: "Erfolgreicht",
        error: "Etwas ist schief gegangen",
        cached: "Änderungen werden gespeichert sobald Sie Online sind. ",
        unsaved: "Änderungen sind eingegeben, bitte vergessen Sie nicht diese zu speichern bevor Sie das Programm verlassen. ",
        offlineUsers: "Arbeitet Offline am Bauplan: ",
        notOnline: "Bitte verbinden Sie sich mit dem Internet",
        inReadOnly: "Derzeit schreibgeschützt. Klicken Sie auf Bearbeiten, um Änderungen vorzunehmen.",
        newSolution: "Neue Lösung",
        chooseSolution: "Wählen Sie eine Lösung",
        draw: "Klicken Sie auf den Bauplan um den Marker zu setzen. ",
        wait1: "Lädt... Dies kann einige Momente dauern ...",
        wait2: "Finale Vorlage wird erstellt",
        todo: "Zu machen",
        todos: "Aufgaben",
        myTodos: "Mein aufgaben",
        todosForInstallers: "Aufgaben für Monteure",
        reports: "Meldungen",
        archivedReports: "Alte meldungen",
        qrcodeNotLinked: "Dieser QR Code ist nicht verknüpft oder mit Markierungen verbunden die sich nicht auf diesem Bauplan befinden. ",
        scanQRCode: "Einen bereits verknüpften QR Code scannen.",
        attachment: "Anhang",
        isEditing: "in Bearbeitung",
        editStart: "Bearbeitung gestartet",
        noaccess: "kein Zugang",
        fillinrequiredfields: "Füllen Sie die erforderlichen Felder aus",
        withlogo: "Mit logo",
        withoutlogo: "Ohne logo",
        search: "Suchen",
        chooseFile: "Datei wählen (5MB max)",
        continuereadonly: "Jemand bearbeitet diese Bauplan. Möchten Sie die Seite trotzdem besuchen, ohne die Möglichkeit zu haben, sie zu bearbeiten?",
        blueprintLocked: "arbeitet an diese Blauplan",
        blueprintLockedSince: "arbeitet an diese Blauplan seit",
        takeOver: "Übernehmen",
        customsolutions: "Eigene Lösungen",
        noproducts: "Keine Produkte",
        addpicture: "Bild hinzufügen",
        help: "Hilfe",
        noresults: "Keine Ergebnisse",
        signout: "Abmelden",
        viewMore: "Mehr sehen",
        usethisinmarker: "Benutze dies in marker",
        addyourownlogo: "Fügen Sie Ihr eigenes Logo hinzu",
        delete: "Löschen",
        step: 'Schritt',
        application: 'Installationsanleitung',
        solutionselector: 'Solution Selector',
        selectsolution: 'Wählen Sie eine Lösung',
        inProcess: 'In Bearbeitung',
        solutionsList: "Lösungsliste",
        deleteSolution: "Lösung löschen",
        selectUsedProducts: "Gebrauchte Produkte auswählen",
        showAll: "Zeige alles",
        new: "Neu",
        useSolutionSelector: 'Finden Sie die richtige Lösung mit dem solution selector',
        orUseDropdown: 'Oder durchsuchen Sie die Liste',
        useDropdown: 'Wählen Sie die richtige Lösung aus dieser Liste',
        info_broken: "Markierung, bei dem das System als „defekt“ bezeichnet  ist",
        info_inProcess: "Markierung mit z.T. fehlenden Informationen (z.B. ohne Bilder, einige Details sind jedoch ausgefüllt)",
        info_approved: "Markierung, bei dem das System als „in Ordnung/genehmigt“ bezeichnet ist",
        info_new: "Neu erstellt Markierung, mit fehlenden Informationen.",
        info_solutions_list: "Sie können mehrere Penetrationsdichtungen (Lösungen) in einem Markierungspunkt haben.",
        showBlueprintImage: "Bauplan anzeigen",
        changeImage: "Bild ändern",
        newAttribute: "Eigenschaft hinzufügen",
        enterTheNameOfYourCustomSolution: "Geben Sie den Namen Ihrer Lösung ein",
        yourProducts: "Liste Ihrer Produkte",
        enterTheNameOfYourProductAndClickThePlusSignToAddToTheList: "Geben Sie den Namen Ihres Produkts ein und klicken Sie auf das Pluszeichen, um es der Liste hinzuzufügen",
        changeSolution: "Lösung ändern",
        viewSolution: "Lösungsinfo anzeigen",
        notLinked: "nicht mit qr code verknüpft",
        linked: "verknüpft mit qr code",
        open: "anzeigen",
        archive: "archivieren",
        restore: "wiederherstellen",
        archivedProjects: "Archivierte Projekte",
        pictures: "Bilder",
        discard: "Verwerfen",
        findInList: "in Liste suchen",
        findInSolutionSelector: "in Solution Selector suchen",
        uploadBlueprintImage: "Hochladen",
        networkIssues: "Netzwerkproblem",
        checkConnectionAndTryAgain: "Überprüfen Sie Ihre Verbindung und Versuch es noch einmal",
        retry: 'Versuch es noch einmal',
        noBlueprints: 'Keine geschosse ',
        noProjects: 'Keine Projekte',
        noBuildingComponents: 'Keine Bauabschnitte',
        noArchivedProjects: 'Keine archivierten Projekte',
        noCustomSolutions: 'Keine eigene Lösungen',
        projectDetails: "Projekt info",
        buildingComponentDetails: "Bauabschnitt info",
        user: "benutzer",
        newUser: "neuer Benutzer",
        breakLock: "sperren",
        changeLogo: "logo ändern",
        vat: "Umsatzsteuer-Identifikationsnummer",
        requestTrial: "Testzugang anfordern",
        freeDemo: "Kostenlose Demo",
        company: "Firma",
        firstFloor: "Beispiel: erster Stock",
        blockA: "Beispiel: Block A.",
        demoRegistrationSuccessful: "Demo-Anfrage erhalten",
        requestReceived: "Anfrage erhalten",
        contactYou: "Anmeldung erfolgreich. Sie erhalten parallel eine Bestätigungsmail auf Ihre angegeben E-Mailadresse.",
        takealook: "Die smarte Software für Ihre Brandschutzdokumentation",
        manufacturerIndepentent: "Herstellerunabhängig",
        multiplesealsonmarker: "Integrierte Produktlösungen mit aktuellen Dokumenten",
        anydevice: "Zugriff an jedem Ort, zu jeder Zeit, auf allen Endgeräten",
        multilanguage: "Individuell organisiert",
        highlyCustomizable: "Einfach & Schnell",
        requestADemo: "Anfrage Firelog",
        signup: "Anmelden",
        activeProjects: "Aktive Projekte",
        profile: "Profil",
        license: "Lizenz",
        storage: "Datenspeicher",
        chooseYourPartner: "Wählen Sie Ihren Partner",
        partner: "partner",
        noPartner: "Kein partner",
        requestTrialFourteenDays: "Registrieren Sie sich für ein 14-tägiges kostenloses Testkonto",
        itemsPerPage: "Objekte pro Seite",
        belgium: "Belgien",
        unitedKingdom: "Vereinigtes Königreich",
        germany: "Deutschland",
        austria: "Österreich",
        romania: "Rumänien",
        sweden: "Schweden",
        hungary: "Ungarn",
        netherlands: "Niederlande",
        norway: "Norwegen",
        switzerland: "Schweiz",
        spain: "Spanien",
        downloadLogbook: "Logbuch herunterladen",
        saveMarkerPosition: "Markierungsposition speichern",
        newMarker: "Neuen Marker hinzufügen",
        fullscreen: "Vollbildschirm",
        noLogin: "Ich habe keinen Account",
        report: "Ein Problem melden",
        send: "Senden",
        checkInbox: "Überprüfen Sie Ihren Posteingang.",
        resetPasswordInstruction: "Sie erhalten eine E-Mail mit weiteren Anweisungen.",
        resetPassword: "Passwort zurücksetzen",
        forgotPassword: "Passwort vergessen?",
        areyouSureYouWantToUpgrade: "Möchten Sie wirklich AMOUNT GB für PRICE pro Monat hinzufügen?",
        perMonth: "pro Monat",
        chooseHowMuchStorageYouWantToAdd: "Wählen Sie aus, wie viel Speicher Sie hinzufügen möchten. Hinweis: Sie können insgesamt bis zu 40 GB Speicherplatz haben. Willst du mehr? Bitte kontaktieren Sie uns.",
        addStorage: "Speicher hinzufügen",
        manageUsers: "Wählen Sie aus, auf welche Projekte, Bauteile und Baupläne diese Person zugreifen kann.",
        properties: "Eigenschaften",
        termsOfService: "Nutzungsbedingungen",
        readAndAccepted: "Ich habe die Nutzungsbedingungen und Datenschutzbestimmungen gelesen und akzeptiert.",
        agree: "Zustimmen",
        contactFunction: "Position des Kontaktes",
        contactEmail: "Kontakt E-mail",
        contactEmailHint: "Wir werden Sie auf diese E-Mail kontaktieren.",
        loginEmail: "Login E-Mail",
        loginEmailHint: "E-Mail-Adresse, mit der Sie sich anmelden können.",
        loginAlreadyExist: "Login-E-Mail wurde bereits verwendet.",
        whatsnew: "Was gibt's Neues",
        deleteBlueprintImage: "Bauplanbild löschen",
        '7profile': "Administrator",
        '8profile': "Nur Lesezugriff",
        '14profile': "Monteur",
        '15profile': "kein Zugang",
        clone: "Klonen",
        cloneAttributeWithValues: "Dieses Attribut mit zugrunde liegenden Werten klonen?",
        giveADifferentName: "Geben Sie einen anderen Namen als das Original ein",
        ignore: "Ignorieren",
        areyousureyouwanttoignorethis: "Bist du sicher, dass du das ignorieren willst?",
        info_delete_attribute: "Sie können Attribute oder Werte löschen, wenn Sie sie selbst erstellt haben und wenn sie noch nicht für eine Markierung verwendet wurden.",
        info_clone_attribute: "Sie können Attribute mit ihren zugrunde liegenden Werten klonen, sodass Sie keine neuen manuell erstellen müssen",
        info_sync_attribute: "Dadurch werden die Standard-Firelog-Attribute und -Werte synchronisiert. Es wird ab und zu empfohlen.",
        info_drag_attribute: "Sie können die Reihenfolge ändern, indem Sie die Maustaste gedrückt halten und an die richtige Position ziehen.",
        info_star_attribute: "Standardattribute und -werte aus Firelog",
        newReports: "neuer Meldungen",
        moveMarker: "Markierungen verschieben",
        markerLabel: "Eigener Markierungsname",
        blueprintSeparated: "Bauplanbild getrennt",
        blueprintSeparatedHint: "Bauplanbild mit Markierungen in hoher Qualität",
        withDocuments: "Mit Dokumenten",
        withDocumentsHint: "Zertifikate, Datenblätter, ... Das kann länger dauern",
        selectYourPage: "Wählen Sie Ihre Seite",
        downloadlogbookasaWordFile: "Logbuch als Word-Dokument herunterladen",
        takingSnapshot: "Einen Schnappschuss vom Blaupausenbild machen",
        modifiedBy: "Geändert durch",
        installPWA: "Firelog auf Ihrem Gerät installieren: Klicken Sie auf ",
        addToHomeScreen: "und dann zum Startbildschirm hinzufügen",
        readyForOffline: "Bereit für Offline, schalten Sie Ihr WLAN / 4G aus, um offline zu arbeiten, und schalten Sie es wieder ein, wenn Sie fertig sind.",
        goOnline: "Vergessen Sie nicht, eine Verbindung zum Internet herzustellen, um Ihre Änderungen zu speichern. Aktualisieren oder schließen Sie die App nicht."
    },
    NN: {
        name: "Navn",
        building: "Byggets navn",
        description: "Beskrivelse",
        order: "Ordre",
        status: "Status",
        actions: "Aktivitet",
        marker: "Markør",
        markerName: "Markør navn",
        class: 'Klasse',
        buildingComponent: "Byggkomponent",
        buildingComponents: "Byggkomponenter",
        createdTs: "Opprettelsesdato",
        markers: "Markør",
        markUp: "Markør brukes på plantegning",
        values: "Verdier",
        inUse: "I bruk",
        firstname: "Fornavn",
        building: "Byggets navn",
        marker: "Markør name",
        description: "Beskrivelse",
        street: "Gate",
        number: "nr",
        postalcode: "Postnr.",
        city: "By",
        country: "Land",
        mobile: "Mobil",
        email: "E-post",
        applicationDate: "Applikasjonsdato",
        date: "Dato",
        attribute: "Egenskap",
        attributes: "Egenskaper",
        value: "Verdi",
        installer: "Installatør",
        solution: "Solution",
        solutions: "Løsninger",
        username: "Brukernavn",
        password: "Passord",
        uploadBlueprintFile: "Last opp plantegning med minimum oppløsning 640x480 (.jpg .pdf fil)",
        comments: "Kommentar",
        approved: "Godkjent",
        broken: "i stykker",
        dimensions: "Dimensjon",
        width: "Bredde (mm)",
        height: "Høyde (mm)",
        length: "Veggtykkelse (mm)",
        diameter: "Diameter (mm)",
        unit: "Enhet",
        amount: "Antall",
        details: "Detaljer",
        required: "påkrevd",
        invalid: "ugyldig",
        overrideQRId: "Advarsel",
        qrIdExists: "Feil",
        success: "Vellykket",
        cached: "Offline",
        saveChanges: "Lagre endringer?",
        overrideQRId: "Denne gjennomføringen er allerede knyttet til en QR-kode. Vil du tilordne den med en ny QR-Kode?",
        qrIdExists: "QR-koden kan ikke brukes. En annen gjennomføring bruker QR-koden!",
        success: "QR-koden er koblet opp med  gjenomføringen!",
        areYouSure: "Er du sikker å slette?",
        cached: "jennomføring vil kobles opp automatisk når du er online.",
        unsaved: "Det ble gjort endringer. Vil du beholde endringene?",
        yes: "Ja",
        no: "Nei",
        currentPassword: "Gjeldende passord",
        newPassword: "Nytt passord",
        confirmPassword: "Bekreft passord",
        changePassword: "Endre passord",
        active: "Aktiv",
        newProject: "Nytt prosjekt",
        newBuildingComponent: "Ny byggkomponent",
        newBlueprint: "Ny plantegning",
        save: "Lagre",
        add: "Legg til",
        close: "Lukk",
        login: "Logg inn",
        newInstaller: "Legg til installatør",
        addPicture: "Legg til bildet",
        newSolution: "Legg til løsning",
        addQRCode: "Link QR Kode",
        offline: "Offline",
        addMarkers: "Legg til  markør",
        cancel: "Avbryt",
        download: "Last ned",
        edit: "Rediger",
        addProduct: "Legg til produkt",
        home: "Hjem",
        projects: "Prosjekter",
        blueprints: "Plantegninger",
        project: "Prosjekt",
        blueprint: "Plantegning",
        marker: "Markør",
        address: "Adresse",
        contact: "Kontakt",
        settings: "Instillinger",
        back: "Tilbake",
        installer: "Installatør",
        users: "Brukere",
        camera: "Kamera",
        solutions: "Løsninger",
        solution: "Løsning",
        products: "Produkte",
        product: "Produkt",
        userNotFound: "Passordet du oppga er feil.",
        selectSolution: "Velg en løsning",
        success: "Vellykket",
        error: "Noe gikk galt",
        cached: "Endringer lagres når du er online",
        unsaved: "Det ble gjort endringer, ikke glem å lagre før du avslutter",
        offlineUsers: "fungerer offline på plantegning: ",
        notOnline: "Vennligst koble til internett",
        inReadOnly: "for øyeblikket i readonly-modus. Klikk rediger for å gjøre endringer.",
        newSolution: "Ny løsning",
        chooseSolution: "Velg løsning",
        draw: "Trykk på plantegning for å lage en markør!",
        wait1: "Laster inn... Dette kan ta noen øyeblikk...",
        wait2: "Forbereder endelig skjema",
        todo: "å gjøre",
        todos: "Gjøremål",
        myTodos: "Min oppgave",
        todosForInstallers: "Dosering for installatører",
        reports: "Rapporter",
        archivedReports: "Gamle rapporter",
        qrcodeNotLinked: "This qr code is not yet linked, or is linked with markers not on this blueprint.",
        scanQRCode: "skann en koblet qr-kode",
        attachment: "Feste",
        isEditing: "Is editing",
        editStart: "Started editing",
        noaccess: "Ingen adgang",
        fillinrequiredfields: "fyll ut de nødvendige feltene",
        withlogo: "Med logo",
        withoutlogo: "Uten logo",
        search: "Søk",
        chooseFile: "Velg Fil (5MB max)",
        continuereadonly: "Noen jobber med denne plantegning. Vil du fremdeles besøke siden uten å kunne redigere?",
        blueprintLocked: "er opptatt med å redigere",
        blueprintLockedSince: "er opptatt med å redigere siden",
        takeOver: "Overta",
        customsolutions: "tilpassede løsninger",
        noproducts: "Ingen produkter",
        addpicture: "Legg til bilde",
        help: "Hjelp",
        noresults: "Ingen resultater",
        signout: "Logg ut",
        viewMore: "Ser mer",
        usethisinmarker: "Bruke det i markør",
        addyourownlogo: "legg til din egen logo",
        delete: "slette",
        step: 'Skritt',
        application: 'Installasjonsinstruksjoner',
        solutionselector: 'Solution Selector',
        selectsolution: 'Velg en løsning',
        inProcess: 'Igang',
        solutionsList: "Løsningsliste",
        deleteSolution: "Slette løsning",
        selectUsedProducts: "Velg brukte produkter",
        showAll: "Ny",
        useSolutionSelector: 'Finn riktig løsning med solution selector',
        orUseDropdown: 'Eller søk i listen',
        useDropdown: 'Velg riktig løsning fra denne listen',
        info_broken: "Markers with their latest image with status broken uploaded. Meaning that the penetration seals are broken.",
        info_inProcess: "Markers that have no images, but some details and information are filled in.",
        info_approved: "Markers that have the penetration seal installed correctly.",
        info_new: "Newly created markers, markers with no info filled in or no images uploaded.",
        info_solutions_list: "You can have multiple penetration seals (solutions) in one marker point.",
        showBlueprintImage: "Vis blåkopisbilde",
        changerImage: 'endre bilde',
        newAttribute: "nytt attributt",
        enterTheNameOfYourCustomSolution: "Skriv inn navnet på løsningen",
        yourProducts: "Liste over produktene dine",
        enterTheNameOfYourProductAndClickThePlusSignToAddToTheList: "Skriv inn navnet på produktet og klikk på pluss-tegnet for å legge det til i listen",
        changeSolution: "endre løsning",
        viewSolution: "vis løsningsinfo",
        notLinked: "Ikke knyttet til qr-kode",
        linked: "Knyttet til qr-kode",
        open: "show",
        archive: "Arkiv",
        restore: "restaurere",
        archivedProjects: "Arkiverte prosjekter",
        pictures: "Bilder",
        discard: "Forkast",
        findInList: "finn i listen",
        findInSolutionSelector: "finn i Solution Selector",
        uploadBlueprintImage: "Laste opp",
        networkIssues: "nettverksproblem",
        checkConnectionAndTryAgain: "Sjekk forbindelsen din og prøv igjen",
        retry: 'Prøv igjen',
        noBlueprints: 'Ingen tegninger',
        noProjects: 'Ingen prosjekter',
        noBuildingComponents: 'Ingen Byggkomponenter',
        noArchivedProjects: 'Ingen arkiverte prosjektere',
        noCustomSolutions: 'Ingen tilpassede løsninger',
        projectDetails: "Projekt info",
        buildingComponentDetails: "byggkomponent info",
        user: "bruker",
        newUser: "ny bruker",
        breakLock: "låse",
        changeLogo: "endre logo",
        vat: "MVA-nummer",
        requestTrial: "Be om en gratis prøveperiode",
        freeDemo: "Gratis demo",
        company: "Bedrift",
        firstFloor: "eksempel: første etasje",
        blockA: "eksempel: blokk A",
        demoRegistrationSuccessful: "Demo-forespørsel mottatt",
        requestReceived: "Forespørsel mottatt",
        contactYou: "Takk for interessen din for Firelog. En representant vil ta kontakt om kort tid for å planlegge din interaktive demo.",
        takealook: "Ta en titt på hvordan du kan registrere brannsikre tetninger hos Firelog",
        manufacturerIndepentent: "Installer på hvilken som helst enhet",
        multiplesealsonmarker: "Flere sel på en markør",
        anydevice: "Last ned prosjektet til et loggbokdokument",
        multilanguage: "Tilgjengelig på flere språk",
        highlyCustomizable: "Meget tilpassbar",
        requestADemo: "Be om en demo",
        signup: "Melde deg på",
        activeProjects: "Aktive Prosjekter",
        profile: "Profil",
        license: "Tillatelse",
        storage: "Oppbevaring",
        chooseYourPartner: "Velg din partner",
        partner: "partner",
        noPartner: "Ingen partner",
        requestTrialFourteenDays: "Registrer deg for en 14-dagers gratis prøvekonto",
        itemsPerPage: "Varer per side",
        belgium: "Belgia",
        unitedKingdom: "Storbritannia",
        germany: "Tyskland",
        austria: "Østerrike",
        romania: "Romania",
        sweden: "Sverige",
        hungary: "Ungarn",
        netherlands: "Nederland",
        norway: "Norge",
        switzerland: "Schweiz",
        spain: "Spania",
        downloadLogbook: "Last ned loggbok",
        saveMarkerPosition: "Lagre markørposisjon",
        newMarker: "Legg til ny markør",
        fullscreen: "Full skjerm",
        noLogin: "Jeg har ikke en konto",
        report: "Rapporter et problem",
        send: "Sende",
        checkInbox: "Sjekk innboksen.",
        resetPasswordInstruction: "Du vil motta en e-post med nærmere instruksjoner.",
        resetPassword: "Tilbakestille passord",
        forgotPassword: "Glemt passord?",
        areyouSureYouWantToUpgrade: "Er du sikker på at du vil legge til AMOUNT GB for PRICE per måned?",
        perMonth: "per måned",
        chooseHowMuchStorageYouWantToAdd: "Velg hvor mye lagringsplass du vil legge til. Merk: Du kan ha opptil 40 GB lagringsplass totalt. Vil du ha mer? Værsåsnill kontakt oss.",
        addStorage: "Legg til lagring",
        manageUsers: "Velg hvilke prosjekter, bygningskomponenter og tegninger denne personen har tilgang til.",
        properties: "Egenskaper",
        termsOfService: "Servicevilkår",
        readAndAccepted: "Jeg har lest og godtatt vilkårene for bruk og personvern.",
        agree: "Bli enige",
        contactFunction: "Funksjon",
        contactEmail: "Kontakt Epost",
        contactEmailHint: "Vi vil kontakte deg på denne e-postmeldingen.",
        loginEmail: "Innloggingsadresse",
        loginEmailHint: "E-postadresse som du kan logge inn med.",
        loginAlreadyExist: "Påloggings-e-post er allerede brukt.",
        whatsnew: "Hva er nytt",
        deleteBlueprintImage: "Slette bygningsplanbilde",
        '7profile': "Administrator",
        '8profile': "Les bare",
        '14profile': "Montør",
        '15profile': "Ingen adgang",
        clone: "Klone",
        cloneAttributeWithValues: "Vil du klone dette attributtet med underliggende verdier?",
        giveADifferentName: "Skriv inn et annet navn enn originalen",
        info_star_attribute: "Standardattribute und -werte aus Firelog",
        ignore: "Overse",
        areyousureyouwanttoignorethis: "Er du sikker på at du vil ignorere dette?",
        info_delete_attribute: "Du kan slette attributter eller verdier hvis du har laget dem selv, og hvis de ikke har blitt brukt ennå på en markør.",
        info_clone_attribute: "Du kan klone attributter med deres underliggende verdier, slik at du ikke trenger å lage nye manuelle",
        info_sync_attribute: "Dette vil synkronisere standard firelog-attributter og -verdier. Det anbefales dette en gang i blant.",
        info_drag_attribute: "Du kan endre rekkefølgen ved å holde klikk og dra den til riktig posisjon.",
        info_star_attribute: "Standard attributter og verdier fra Firelog",
        newReports: "Nye rapporter",
        moveMarker: "Flytt markører",
        markerLabel: "Markør etikett",
        blueprintSeparated: "byggeplan bilde atskilt",
        blueprintSeparatedHint: "Få tegningsbildet ditt med markører skilt i høy kvalitet (.jpg)",
        withDocuments: "Inkluder sertifiseringsdokumenter",
        withDocumentsHint: "Sertifikater, datablad, ... Dette kan ta mer tid",
        selectYourPage: "Velg siden din",
        downloadlogbookasaWordFile: "Loggbok lastes ned som Word-dokument",
        takingSnapshot: "Einen Schnappschuss vom Blaupausenbild machen",
        modifiedBy: "Endret av",
        installPWA: "Installer Firelog på enheten din: trykk på ",
        addToHomeScreen: "og deretter Legg til på startskjermen",
        readyForOffline: "Klar for offline, slå av wifi / 4g for å jobbe offline og slå den på når du er ferdig.",
        goOnline: "Ikke glem å koble til internett for å lagre endringene. Ikke oppdater eller lukk appen."
    },
    SV: {
        "name": "Name",
        "building": "Byggnadens namn",
        "description": "Beskrivning",
        "order": "Order",
        "status": "Status",
        "actions": "Utförande",
        "marker": "Markör",
        "markerName": "Markörens namn",
        "buildingComponent": "Byggnadsdel",
        "buildingComponents": "Byggnadsdelar",
        "createdTs": "Skapat datum",
        "blueprints": "Ritningar",
        "markers": "Markörer",
        "markUp": "Hantera markörer på ritning",
        "values": "Värde",
        "inUse": " I bruk",
        "firstname": "Förnamn",
        "street": "Gata",
        "number": "Nummer",
        "postalcode": "Postnummer",
        "city": "Stad",
        "country": "Land",
        "mobile": "Mobil",
        "email": "E-post",
        "applicationDate": "Ansökningsdatum",
        "date": "Datum",
        "class": "Klass",
        "attribute": "Egenskap",
        "attributes": "Egenskaper",
        "value": "Värde",
        "installer": "Montör",
        "solution": "Lösning",
        "solutions": "Lösningar",
        "username": "Användarnamn",
        "password": "Lösenord",
        "uploadBlueprintFile": "Ladda upp ritning med minsta upplösning 640x480 (.jpg .pdf fil)",
        "comments": "Kommentarer",
        "products": "Produkter",
        "approved": "Godkänd",
        "broken": "Bruten",
        "dimensions": "Dimensioner",
        "width": "Bredd (mm)",
        "height": "Höjd (mm)",
        "length": "Längd (mm)",
        "diameter": "Diameter (mm)",
        "unit": "Enhet",
        "amount": "Belopp",
        "details": "Detaljer",
        "required": "Krävs",
        "invalid": " Ogiltigt",
        "warning": "Varning",
        "qrIdExists": "Denna QR-kod kan inte tillämpas. En annan brandgenomföring använder denna QR-kod!",
        "success": "Klart!",
        "cached": "Ändringar sparas när du är online",
        "saveChanges": "Spara ändring?",
        "overrideQRId": "Denna brandgenomföring är redan kopplad till en QR-kod. Vill du tilldela den med en ny QR-kod?",
        "areYouSure": "Är du säker på att du vill ta bort det här?",
        "unsaved": "Ändringar gjordes, glöm inte att spara innan du lämnar.",
        "yes": "Ja",
        "no": "Nej",
        "currentPassword": "Nuvarande lösenord",
        "newPassword": "Nytt lösenord",
        "confirmPassword": "Bekräfta lösenord",
        "changePassword": "Byta lösenord",
        "active": "Aktiv",
        "noBlueprint": "Jag har för nävarande ingen ritning",
        "deadline": "skall vara klart",
        "newProject": "Nytt projekt",
        "newBuildingComponent": "Ny byggnadsdel",
        "newBlueprint": "Ny ritning",
        "save": "Spara",
        "add": "Lägg till",
        "close": "Stäng",
        "login": "Logga in",
        "newInstaller": "Lägg till montör",
        "addPicture": "Lägg till bild",
        "newSolution": "Ny lösning",
        "addQRCode": "Lägg till QR-kod",
        "offline": "Offline",
        "addMarkers": "Lägg till markörer",
        "cancel": "Avbryt",
        "download": "Ladda ner",
        "edit": "Redigera",
        "addProduct": "Lägg till produkt",
        "home": "Hem",
        "projects": "Projekt",
        "project": "Projekt",
        "blueprint": "Ritning",
        "address": "Adress",
        "contact": "Kontakt",
        "settings": "Inställningar",
        "back": "Tillbaka",
        "users": "Användare",
        "camera": "Kamera",
        "product": "Produkt",
        "todo": "Att göra",
        "todos": "Att göra",
        "myTodos": "Mina Att göra",
        "todosForInstallers": "Att Göra för installatörer",
        "userNotFound": "User not found ",
        "selectSolution": "Välj en lösning",
        "error": "Något gick fel",
        "offlineUsers": "Arbetet med ritningen sker offline:",
        "notOnline": "Ingen anslutning ",
        "inReadOnly": "för närvarande i readonly-läge. Klicka på redigera för att göra ändringar.",
        "chooseSolution": "Välj en  lösning",
        "draw": "Markera på ritningen för att skapa en markering!",
        "wait1": "Laddar... Detta kan ta några ögonblick...",
        "wait2": "Förbereder slutlig utformning",
        "reports": "Rapporter",
        "archivedReports": "Arkiverade rapporter",
        "qrcodeNotLinked": "Denna QR kod är inte länkad, eller är länkad till en annan ritning.",
        "scanQRCode": "skanna en länkad qr-kod",
        "attachment": "bifoga",
        "isEditing": "Redigerar",
        "editStart": "Startar redigering ",
        "noaccess": "Ingen åtkomst",
        "fillinrequiredfields": "fyll i de obligatoriska fälten",
        "withlogo": "med logga",
        "withoutlogo": "Utan logga",
        "search": "Sök",
        "chooseFile": "Välj FIL (5MB max)",
        "continuereadonly": "Någon arbetar med denna ritning. Vill du fortfarande besöka sidan utan att kunna redigera?",
        "blueprintLocked": "Ritning låst för redigering",
        "blueprintLockedSince": "Ritningen är låst för redigering",
        "takeOver": "Ta över",
        "customsolutions": "Anpassade lösningar",
        "noproducts": "Inga produkter",
        "addpicture": "Lägg till bild",
        "help": "Hjälp",
        "noresults": "Inga resultat",
        "signout": "Logga ut",
        "viewMore": "Visa mer",
        "usethisinmarker": "Använd detta i markören",
        "addyourownlogo": "Lägg till din egen logga",
        "delete": "Radera",
        "step": "Steg",
        "application": "Monteringsanvisning ",
        "solutionselector": "Produktväljare ",
        "selectsolution": "Välj en lösning",
        "inProcess": "Pågående",
        "solutionsList": "Lista på lösningar",
        "deleteSolution": "Ta bort lösning",
        "selectUsedProducts": "Välj använda lösningar.",
        "showAll": "Visa allt",
        "new": "Ny",
        "useSolutionSelector": "Hitta rätt lösning med Produktväljaren ",
        "orUseDropdown": "Eller sök i rulllistan",
        "useDropdown": "Hitta rätt lösning från rull listan",
        "info_broken": " Markör med den status Ej färdig uppladdad. Betyder att tätningen ej är klar.",
        "info_inProcess": "Markören har ingen bild med detaljerad information finns",
        "info_approved": " Markörer som har brandtätningen monterad korrekt",
        "info_new": "Nyligen skapade markörer, markörer utan information och bild",
        "info_solutions_list": " Du kan ha flera olika brantätningar på en markör",
        "showBlueprintImage": "Visa ritning.",
        "changeImage": "ändra bild",
        "newAttribute": "Nya egenskaper",
        "enterTheNameOfYourCustomSolution": "Ange namnet på din lösning",
        "yourProducts": "Lista över dina produkter",
        "enterTheNameOfYourProductAndClickThePlusSignToAddToTheList": "Ange namnet på din produkt och klicka på plustecknet för att lägga till den i listan",
        "changeSolution": "ändra lösning",
        "viewSolution": "visa lösningsinfo",
        "notLinked": "Inte kopplad med qr-kod",
        "linked": "kopplad till qr-kod",
        "open": "öppna",
        "archive": "arkiv",
        "restore": "Återställ",
        "archivedProjects": "Arkiverade projekt",
        "pictures": "Bilder",
        "discard": "Kassera",
        "findInList": "hitta i listan",
        "findInSolutionSelector": "hitta i Solution Selector",
        "uploadBlueprintImage": "Ladda upp",
        "networkIssues": "nätverks problem",
        "checkConnectionAndTryAgain": "Kontrollera din anslutning och försök igen",
        "retry": "Försök igen",
        "noBlueprints": "Inga ritningar",
        "noProjects": "Inga projekt",
        "noBuildingComponents": "Inga Byggnadsdelar",
        "noArchivedProjects": "Inga arkiverade projekt",
        "noCustomSolutions": "Inga anpassade lösningar",
        "projectDetails": "Projekt info",
        "buildingComponentDetails": "byggnadsdel info",
        "user": "användare",
        "newUser": "ny användare",
        "breakLock": "låsa",
        "changeLogo": "ändra logga",
        "vat": "Momsregistreringsnummer",
        "requestTrial": "Begär en gratis provperiod",
        "freeDemo": "Gratis demo",
        "company": "Företag",
        "demoRegistrationSuccessful": "Demo begäran mottagen",
        "requestReceived": "Förfrågan mottagen",
        "contactYou": "Tack för ditt intresse för Firelog. En representant kommer att kontakta inom kort för att schemalägga din interaktiva demo.",
        "firstFloor": "exempel: första våningen",
        "blockA": "exempel: block A",
        "takealook": "Ta en titt på hur du kan registrera brandtätningar hos Firelog",
        "manufacturerIndepentent": "Installera på vilken enhet som helst",
        "multiplesealsonmarker": "Flera tätningar på en markör",
        "anydevice": "Ladda ner ditt projekt till ett loggbokdokument",
        "multilanguage": "Finns på flera språk",
        "highlyCustomizable": "Mycket anpassningsbara",
        "requestADemo": "Begär en demo",
        "signup": "Bli Medlem",
        "activeProjects": "Aktiva projekt",
        "profile": "Profil",
        "license": "Licens",
        "storage": "Lagring",
        "chooseYourPartner": "Välj din partner",
        "partner": "partner",
        "noPartner": "Ingen partner",
        "requestTrialFourteenDays": "Registrera dig för ett 14-dagars gratis provkonto",
        "itemsPerPage": "Objekt per sida",
        "belgium": "Belgien",
        "unitedKingdom": "Storbritannien",
        "germany": "Tyskland",
        "austria": "Österrike",
        "romania": "Rumänien",
        "sweden": "Sverige",
        "hungary": "Ungern",
        "netherlands": "Nederländerna",
        "norway": "Norge",
        "switzerland": "Schweiz",
        "spain": "Spanien",
        "downloadLogbook": "Ladda ner loggbok",
        "saveMarkerPosition": "Spara markörens position",
        "newMarker": "Lägg till ny markör",
        "fullscreen": "Fullskärm",
        "noLogin": "Jag har inget konto",
        "report": "Rapportera ett problem",
        "send": "Skicka",
        "checkInbox": "Kolla din inkorg.",
        "resetPasswordInstruction": "Du får ett e-postmeddelande med ytterligare instruktioner.",
        "resetPassword": "Återställ lösenord.",
        "forgotPassword": "glömt ditt lösenord?",
        "areyouSureYouWantToUpgrade": "Är du säker på att du vill lägga till AMOUNT GB för PRICE per månad?",
        "perMonth": "per månad",
        "chooseHowMuchStorageYouWantToAdd": "Välj hur mycket lagringsutrymme du vill lägga till. Observera: Du kan ha upp till 40 GB lagringsutrymme totalt. Vill du ha mer? Vänligen kontakta oss.",
        "addStorage": "Lägg till lagring",
        "manageUsers": "Välj vilka projekt, byggnadsdelar och ritningar som personen kan komma åt.",
        "properties": "Egenskaper",
        "termsOfService": "Användarvillkor",
        "readAndAccepted": "Jag har läst och accepterat användarvillkoren och sekretesspolicyn.",
        "agree": "Hålla med",
        "contactFunction": "Fungera",
        "contactEmail": "Kontakt e-post",
        "contactEmailHint": "Vi kommer att kontakta dig via den här e-postadressen.",
        "loginEmail": "Logga in e-post",
        "loginEmailHint": "E-postadressen som du kan logga in med.",
        "loginAlreadyExist": "Denna mailadress används redan ",
        "whatsnew": "Vad är nytt",
        "deleteBlueprintImage": "Radera ritning.",
        "7profile": "Administratör",
        "8profile": "Endast läsning",
        "14profile": "Montör",
        "15profile": "Ingen åtkomst",
        "clone": "Klona",
        "cloneAttributeWithValues": "Klona egenskaperna med underliggande värden?",
        "giveADifferentName": "Ange ett annat namn ",
        "ignore": "Ignorera",
        "areyousureyouwanttoignorethis": "Är du säker på att du vill ignorera?",
        "addReportToThisSolution": "Lägg till rapport till den här lösningen",
        "info_delete_attribute": "Du kan ta bort egenskaper eller värden som du lagt till dem själv under förutsättning  att de ännu inte används i en markör.",
        "info_clone_attribute": "Du kan klona egenskaper med deras underliggande värden så att du inte behöver skapa nya",
        "info_sync_attribute": "Detta synkroniserar standardvärden i Firelog.Detta rekomenderas attt man gör med jämna mellanrum.",
        "info_drag_attribute": "Du kan ändra ordningen genom att klicka och dra den till rätt position.",
        "info_star_attribute": "Standardaregenskaper och värden från Firelog",
        "newReports": "Nya rapporter",
        "moveMarker": "Flytta markörer",
        "markerLabel": "Eget namn på markör",
        "blueprintSeparated": "Separerad ritning  ",
        "blueprintSeparatedHint": "Få din ritnings med markörer separerade i hög kvalitet (.jpg)",
        "withDocuments": "Inkludera dokument",
        "withDocumentsHint": "Certifikat, datablad, ... Kan ta längre tid att ladda upp.",
        "selectYourPage": "Välj din sida",
        "downloadlogbookasaWordFile": "Loggbok laddas ned som Word-dokument",
        "takingSnapshot": "Ta en \"Snapshot\" av ",
        "modifiedBy": "Modifierad av",
        "installPWA": "Installera Firelog på din enhet: Tryck här",
        "addToHomeScreen": " Lägg sedan till på startskärmen",
        "readyForOffline": "Klar för offline, stäng av din wifi / 4G för att arbeta offline och slå på den igen när du är klar.",
        "goOnline": "Glöm inte att ansluta till internet för att spara dina ändringar. Uppdatera inte och stäng inte appen.",
        "changerImage": "Ändra bild",
        "addpicutre": "Lägg till bild",
        "tep": "Steg"
    },
}

export default locales;


// WEBPACK FOOTER //
// ./src/settings/locales.js